/* eslint-disable sciencepo-rules/require-story*/
/* Inutile de le tester*/
import {isExternalLink, toExternalUrl} from '../../utils/utils';
import * as styleLink from '../../styles/communs/polylink.module.scss';
import PropTypes from 'prop-types';
import {Link} from 'gatsby';
import React from 'react';
import clsx from 'clsx';
import {useTranslation} from 'react-i18next';

const PolyLink = React.memo(function PolyLink ({
  children,
  url,
  target,
  style,
  className,
  notFocus,
  id,
  ariaLabel,
  dataCy,
}) {
  const {t} = useTranslation();
  const conditionalAttrLink = {};

  if (id) {
    conditionalAttrLink.id = id;
  }

  if (target) {
    conditionalAttrLink.target = target;
  }

  if (!url) {
    return (
      <span className={className}>
        {children}
      </span>
    );
  }
  if (target !== '_blank' && url !== '#' && !isExternalLink(url)) {
    return (
      <Link
        data-cy={dataCy}
        {...conditionalAttrLink}
        aria-label={ariaLabel}
        className={className}
        style={style}
        tabIndex={notFocus ? -1 : ''}
        to={url}
      >
        {children}
      </Link>
    );
  }
  return (
    <a
      title={(target !== '_blank' ? '' : `${ariaLabel ? ariaLabel : t('polylink.no_title')} - ${t('polylink.blank')}`)}
      {...conditionalAttrLink}
      aria-label={ariaLabel}
      className={clsx(className, {[styleLink.blank]: conditionalAttrLink.target === '_blank'})}
      data-cy={dataCy}
      href={toExternalUrl(url)}
      rel="noopener noreferrer"
      style={style}
      tabIndex={notFocus ? -1 : ''}
    >
      {children}
    </a>
  );
});

PolyLink.propTypes = {
  ariaLabel: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  dataCy: PropTypes.string,
  id: PropTypes.string,
  keyid: PropTypes.string,
  name: PropTypes.string,
  notFocus: PropTypes.bool,
  style: PropTypes.object,
  target: PropTypes.string,
  url: PropTypes.string,
};

export default PolyLink;
